<template>
  <nav class="kye-sidebar noselect"
       :style="widthStyle">
    <el-autocomplete
      ref="searchMenu"
      v-model="searchKey"
      clearable
      placeholder="名称或首字母"
      class="menu-popper"
      :class="{'menu-popper__collapse': isCollapse}"
      data-autocomplete="off"
      :popper-class="popperClass"
      :trigger-on-focus="false"
      :fetch-suggestions="searchMenu"
      @focus="focusAutoComplete"
      @select="selectMenu">
      <i slot="prefix"
         class="layout layout-search"
         :style="{cursor: isCollapse ? 'pointer' : '', fontSize: '14px'}"
         @click="handleOpenMenu"></i>
      <template slot-scope="{ item }">
        <p class="title">{{ item.$title }}</p>
        <p class="kyeword">{{ item.$kyeWord }}</p>
      </template>
    </el-autocomplete>
    <el-scrollbar>
      <!-- <SideMenu :isCollapse="isCollapse" /> -->
      <kye-menu unique-opened="true" sync="true"></kye-menu>
    </el-scrollbar>
    <div class="btn-collapse"
         :style="widthStyle"
         @click="switchMenu">
      <i class="layout" :class="collapseClass"></i>
    </div>
    <!-- 外链菜单 -->
    <a ref="href" hidden target="_blank" rel="nofollow noopener noreferrer"></a>
  </nav>
</template>

<script>
  import bus from 'public/utils/bus'
  import { HOME_MENUS } from 'public/config'
  import { getToken } from 'public/utils'
  import { QtReportOpenMenuBySearch } from '@/layout/utils/report-qt.js'
  // import SideMenu from './side-menu.vue'

  const MENU_WIDTH = { full: 160, small: 48 }
  // 已选菜单的历史记录定义
  const ERP_MENU_SELECTED = 'erp_menu_selected'

  export default {
    name: 'sidebar',
    // components: { SideMenu },
    props: {
      width: {
        type: Number,
        default: MENU_WIDTH.full
      }
    },
    data () {
      return {
        theme: '',
        isCollapse: false, // 菜单栏是否被折叠
        searchKey: ''
      }
    },
    created () {
      this.$bus.$on('GLOBAL_SWITCH_MENU', this.switchMenuByBus)
      this.$bus.$on('SET_THEME', this.themeChange)
    },
    beforeDestroy () {
      this.$bus.$off('GLOBAL_SWITCH_MENU', this.switchMenuByBus)
      this.$bus.$off('SET_THEME', this.themeChange)
    },
    computed: {
      visitedViews () {
        return this.$store.state.tagsView.visitedViews
      },
      widthStyle () {
        return { width: `${this.width}px` }
      },
      searchedMenus () {
        return Object.values(this.$store.getters.menus).filter(v => v.$title && !HOME_MENUS.includes(v.menuCode))
      },
      collapseClass () {
        return this.isCollapse ? 'layout-collapse-hidden1' : 'layout-collapse-visible1'
      },
      popperClass () {
        let str = 'kye-popper-auto'
        if (this.theme === 'dark') {
          str += ' kye-popper-auto_dark'
        }
        return str
      },
    },
    methods: {
      handleOpenMenu () {
        if (this.isCollapse) {
          this.switchMenu()
        }
      },
      switchMenu () {
        this.isCollapse = !this.isCollapse
        let w = this.isCollapse ? MENU_WIDTH.small : MENU_WIDTH.full
        this.$emit('switch-menu', w)
        this.$bus.$emit('SWITCH_MENU', w, this.isCollapse)
        document.documentElement.style.setProperty('--menu-width', w + 'px')
      },
      switchMenuByBus (isExpand = false) {
        this.isCollapse = isExpand
        this.switchMenu()
      },
      pushRoute (path, keyword = '') {
        if (!path || path.startsWith('http')) {
          this.openLink(path)
          QtReportOpenMenuBySearch(path)
          return
        }
        // 从框架布局进入，添加入口标记
        const route = this.$router.resolve(path).route
        route.meta.layout = true
        keyword && (route.meta.searchKeyword = keyword)
        const currentRoute = this.visitedViews.find(t => t.tag === path)
        bus.$emit('GLOBAL_USE_OPEN_MODULE', route.meta.tag || path)
        if (currentRoute) {
          // 需要设置跳转页面的 layout 为 true，解决搜索菜单进入已存在的详情页时 layout 为 false 页面没保活的问题
          const currentPathRoute = this.$router.resolve(currentRoute.path).route
          currentPathRoute && (currentPathRoute.meta.layout = true)
          this.$router.push(currentRoute.path)
          this.$bus.$emit('TAB_CLICK', currentRoute.path, currentRoute.tag)
          QtReportOpenMenuBySearch(currentRoute.path)
        } else {
          this.$router.push(path)
          this.$bus.$emit('TAB_CLICK', path, path)
          QtReportOpenMenuBySearch(path)
        }
      },
      searchMenu (val, cb) {
        const res = []
        if (val) {
          const letter = /^[a-zA-Z]+$/
          const en = letter.test(val)
          this.searchedMenus.forEach(v => {
            if ((en && v.$title_en.includes(val)) || v.$title.includes(val)) {
              res.push(v)
            } else {
              let keyword = v.$kyeWord ? v.$kyeWord.split(',') : []
              let str = keyword.find(v => v.includes(val))
              if (str) {
                res.push({
                  ...v,
                  $kyeWord: str
                })
              }
            }
          })
        }
        cb(res)
        // 自动选择第一行
        this.$nextTick(_ => {
          res.length && this.$refs['searchMenu'].highlight && this.$refs['searchMenu'].highlight(0)
        })
      },
      // 缓存已选菜单作为历史记录
      cacheSelectedMenu (data) {
        if (!data) return
        let selectedMenus = JSON.parse(localStorage.getItem(ERP_MENU_SELECTED)) || []
        const index = selectedMenus.findIndex(menu => menu.menuCode === data.menuCode)
        if (index === -1) {
          selectedMenus.unshift({ menuCode: data.menuCode })
          selectedMenus = selectedMenus.slice(0, 5) // 最多5个
          localStorage.setItem(ERP_MENU_SELECTED, JSON.stringify(selectedMenus))
        }
      },
      selectMenu (val) {
        let key = ''
        try {
          key = this.$refs.searchMenu.$refs.input.value
        } catch (e) {
          console.error(e)
        }
        this.pushRoute(val.menuCode, key)
        this.searchKey = ''
        this.cacheSelectedMenu(val)
      },
      focusAutoComplete () {
        // 聚焦时，选择合适时机显示历史选择的逻辑
        let selectedMenus = JSON.parse(localStorage.getItem(ERP_MENU_SELECTED))
        // 判断是否存在已选的历史操作数据，并且当前的输入内容为空时，即未输入。设置面板
        if (!this.searchKey && Array.isArray(selectedMenus) && selectedMenus.length) {
          const menuList = this.$store.state.menus
          // 仅保留菜单列表中存在的菜单
          const newSelectedMenus = selectedMenus.map(v => {
            const menuItem = menuList[v.menuCode]
            // 取最新的明细数据，避免缓存数据污染
            return menuItem && { ...v, $title: menuItem.$title, $kyeWord: menuItem.$kyeWord }
          }).filter(Boolean)
          this.$refs.searchMenu.suggestions = newSelectedMenus
          // 更新本地存储
          localStorage.setItem(ERP_MENU_SELECTED, JSON.stringify(newSelectedMenus.map(v => ({menuCode: v.menuCode}))))
        }
      },
      openLink (path) {
        const token = getToken()
        path = `${path}${path.includes('?') ? '&' : '?'}token=${token}`
        const dom = this.$refs.href
        dom.setAttribute('href', path)
        // dom.setAttribute('target', (new URL(path)).hostname)
        dom.dispatchEvent(new MouseEvent('click'))
      },
      themeChange (obj, type) {
        if (!this.rootEl) {
          this.rootEl = this.$el
        }
        if (!type || type === 'menu') {
          if (obj.menu === 'dark') {
            this.theme = 'dark'
            this.rootEl.classList.add('kye-sidebar_dark')
          } else {
            this.theme = ''
            this.rootEl.classList.remove('kye-sidebar_dark')
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .kye-sidebar {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #f7f7f7;

    .el-scrollbar {
      height: 100%;
    }
    .el-scrollbar__wrap {
      height: 100%;
      overflow: scroll;
      overflow-x: hidden;
      // margin-right: -17px !important;
    }
    .el-scrollbar__bar.is-horizontal {
      display: none;
    }
    .menu-popper {
      padding: 10px 16px;
      .el-input__inner {
        padding-left: 26px;
        padding-right: 8px;
        border-radius: 4px;
        color: #333333;
        border-color: #dbdae6;
        background-color: #ffffff;
        &:focus {
          border-color: var(--g-color-primary)
        }
      }
      .el-input__prefix {
        top: 6px;
        padding-left: 4px;
        font-size: 14px;
        color: #b3b1b1;
      }
      &__collapse {
        padding: 16px 12px;
        padding-right: 20px;
        .el-input__inner {
          display: none;
          border-color: transparent;
          background-color: transparent;
        }
        &:hover {
          background-color: #dedee0;
        }
        .el-input__prefix {
          position: static !important;
          padding-left: 0px;
          width: 100%;
          height: 100%;
          color: #1D1C23;
          display: inline-block;
          cursor: pointer;
        }
        .el-input__suffix {
          display: none;
        }
      }
    }
    .btn-collapse {
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #F8F8FA;
      font-size: 14px;
      cursor: pointer;
      i.layout {
        color: #43414C;
        padding: 5px 4px;
        border-radius: 4px;
        font-size: 12px;
        &:hover {
          background-color: rgba(#5C2ED4, 0.1);
          color: #6D2EF8;
        }
      }
      &:active {
        i.layout {
          background-color: rgba(#5C2ED4, 0.2);
          color: #6D2EF8;
        }
      }
    }
  }

  .kye-popper-auto {
    p.title {
      // color: #333333;
    }
    p.kyeword {
      line-height: 1;
      color: #c7c7c7;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 160px;
    }
    &.el-autocomplete-suggestion {
      li {
        color: #1D1C23;
      }
      li:hover, li.highlighted {
        color: #1D1C23;
        background: rgba(#1D1C23, 0.04);
      }
    }
    &_dark {
      .el-autocomplete-suggestion__wrap {
        background-color: #211660;
        border: none;
      }
      &.el-autocomplete-suggestion {
        li {
          color: #FFFFFF;
        }
        li:hover, li.highlighted {
          color: #FFFFFF;
          background: rgba(#6D2EF8, 0.2);
        }
      }
      li {
        color: #FFFFFF;
      }
      .popper__arrow {
        border-bottom-color:#211660!important;
        &::after {
          border-bottom-color:#211660!important;
        }
      }
    }
  }

  // 主题设置
  .kye-sidebar_dark {
    background-color: #150448;
    .menu-popper {
      .el-input__inner {
        color: #ffffff;
        border-color: transparent;
        background-color: #3B3661;
      }
      &__collapse {
        .el-input__inner {
          border-color: transparent;
          background-color: transparent;
        }
        &:hover {
          background-color: #150448;
        }
        .el-input__prefix {
          color: #ffffff;
        }
      }
    }
    .btn-collapse {
      background-color: #150448;
      i.layout {
        color: #ffffff;
        padding: 5px 4px;
        border-radius: 4px;
        &:hover {
          color: #ffffff;
          background-color: rgba(#6D2EF8, 0.2);
        }
      }
      &:active {
        i.layout {
          color: #ffffff;
          background-color: rgba(#6D2EF8, 0.35);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/layout/sidebar.vue